import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as surveyConfiguration from '../../../survey-configuration'
import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Refreshes the current record whenever survey configuration is successfully
 * updated.
 *
 * Relies on this collection's `dataOperation: { useCacheInsteadOfApi: false }`
 * (see collection.ts) so that `getEntity` always hits the API instead of
 * returning a stale cached entity. If that config is ever changed to `true` (or
 * removed), this effect will silently stop actually refreshing data.
 */
export const fetchCurrentEntityOnSurveyConfigurationChange =
  store.effects.create(
    (
      _: ec.Collection<TypeParams>['feature'],
      collection: Collection,
      surveyConfigurationFeature: surveyConfiguration.Feature,
    ) =>
      surveyConfigurationFeature.actions.upsert.success
        .observe()
        .pipe(
          rxjs.map(() =>
            collection.plugins.currentEntityPlugin.feature.actions.getEntity
              .from(
                '(effect) fetch current entity on survey configuration change',
              )
              .create({}),
          ),
        ),
  )
